import { useEffect } from "react";
import connectWebSocket from "../../services/websocketConnection";
import { getSensorStatus } from "../../utils/sensorStatus";

export const useWebSocketSensor = (setSensorList: any) => {
  useEffect(() => {
    let socket: WebSocket;
    let reconnectTimer: ReturnType<typeof setTimeout>;

    const connect = () => {
      socket = connectWebSocket((msg: string) => {
        try {
          const rawParsed = JSON.parse(msg);
          console.log("WebSocket Incoming:", rawParsed);

          // Handle both single object and array of objects
          const parsedArray = Array.isArray(rawParsed) ? rawParsed : [rawParsed];
          const now = new Date().toISOString();

          setSensorList((prev: any[]) =>
            prev.map((sensor) => {
              // Find if there's an update for this sensor in the incoming data
              const update = parsedArray.find(
                (parsed) =>
                  sensor.id === parsed.sensor ||
                  sensor.name === parsed.deviceId ||
                  sensor.name === parsed.sensor ||
                  sensor.id === parsed.deviceId
              );

              if (update) {
                const newR = update.R ?? update.r ?? update.resistance ?? sensor.r ?? sensor.resistance;
                const newG = update.G ?? update.g ?? update.ground ?? sensor.g ?? sensor.ground;
                
                const criticalThreshold =
                  update.criticalResistanceValue ??
                  sensor.criticalThreshold ??
                  sensor.criticalResistanceValue ??
                  3.0;

                return {
                  ...sensor,
                  criticalThreshold,
                  voltage: update.V ?? update.v ?? update.voltage,
                  current: update.I ?? update.i ?? update.current,
                  resistance: newR,
                  ground: newG,
                  // Also set lowercase fields for getSensorStatus & dashboard
                  v: update.V ?? update.v ?? update.voltage,
                  i: update.I ?? update.i ?? update.current,
                  r: newR,
                  g: newG,
                  lastUpdatedAt: now,
                  status: getSensorStatus(newR, now, newG, criticalThreshold),
                };
              }
              return sensor;
            })
          );
        } catch (err) {
          console.error("WebSocket parse error", err);
        }
      });

      socket.onclose = () => {
        console.log("WebSocket closed, attempting to reconnect...");
        reconnectTimer = setTimeout(connect, 3000);
      };

      socket.onerror = (err) => {
        console.error("WebSocket error:", err);
        socket.close();
      };
    };

    connect();

    return () => {
      clearTimeout(reconnectTimer);
      if (socket) {
        socket.onclose = null; // Prevent reconnect on explicit unmount
        socket.close();
      }
    };
  }, [setSensorList]);
};

